import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { BACKEND_URL } from "./../backendconfig";

const api = `${BACKEND_URL.replace(/\/+$/, "")}/admin-auth.php`;

export default function RequireAdmin() {
  const { pathname } = useLocation();
  const [session, setSession] = useState({
    path: "",
    status: "loading",
  });

  useEffect(() => {
    const controller = new AbortController();

    async function checkSession() {
      try {
        const response = await fetch(`${api}?action=session`, {
          credentials: "include",
          cache: "no-store",
          signal: controller.signal,
        });

        const data = await response.json();

        if (!response.ok || !data.ok) {
          throw new Error("Session check failed.");
        }

        if (!controller.signal.aborted) {
          setSession({
            path: pathname,
            status: data.authenticated ? "authenticated" : "guest",
          });
        }
      } catch {
        if (!controller.signal.aborted) {
          setSession({ path: pathname, status: "error" });
        }
      }
    }

    checkSession();

    return () => controller.abort();
  }, [pathname]);

  if (session.path !== pathname || session.status === "loading") {
    return <p role="status">Checking admin session…</p>;
  }

  if (session.status === "error") {
    return (
      <p role="alert">
        Unable to check your session. Reload the page to try again.
      </p>
    );
  }

  return session.status === "authenticated" ? (
    <Outlet />
  ) : (
    <Navigate to="/MyAdmin/login" replace />
  );
}
